import {HospitalList} from "./HospitalList";
import {HospitalEdit} from "./HospitalEdit";
import {HospitalCreate} from "./HospitalCreate";

export default {
    list: HospitalList,
    create: HospitalCreate,
    edit: HospitalEdit
};
